import { Fragment, useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import InfoTooltip from "../../../../Components/InfoTooltip/InfoTooltip"

import styles from "./metricCard.module.less"

// The card's platform info icon (DAA-1-12): "<Card title> — how it's calculated", the card's terms
// with their formulas in order, and the "Not affected by" line last (DAA-1-13). Opens below the
// icon and flips above when there is no room; closes on mouse-out, page scroll or Esc — the last
// two are not antd's own, hence the controlled `open`.
const CardInfo = ({ title, terms, notAffectedBy }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return undefined

    const close = () => setOpen(false)
    const closeOnEscape = (event) => {
      if (event.key === "Escape") close()
    }

    window.addEventListener("keydown", closeOnEscape)
    window.addEventListener("scroll", close, true)

    return () => {
      window.removeEventListener("keydown", closeOnEscape)
      window.removeEventListener("scroll", close, true)
    }
  }, [open])

  const content = (
    <>
      <div className={styles.infoTitle}>{`${title} — ${t("how it's calculated")}`}</div>
      <dl className={styles.infoTerms}>
        {terms.map((term) => (
          <Fragment key={term.name}>
            <dt>{term.name}</dt>
            <dd>{term.formula}</dd>
          </Fragment>
        ))}
      </dl>
      {notAffectedBy && <div className={styles.infoNote}>{notAffectedBy}</div>}
    </>
  )

  return (
    <InfoTooltip
      title={content}
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
      arrow={false}
      overlayClassName={styles.infoOverlay}
    />
  )
}

export default CardInfo
